import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-action-box',
  templateUrl: './action-box.component.html',
  styleUrls: ['./action-box.component.scss'],
  standalone: false,
})
export class ActionBoxComponent {
  @Input()
  icon: string;

  @Input()
  title: string;

  @Input()
  description: string;

  @Input()
  comingSoon: boolean;

  @HostBinding('class')
  private get isDisabled(): string {
    return this.comingSoon ? 'opacity-50 pointer-events-none' : '';
  }

  buildTranslationKey(key: string): string {
    return `actionBox.${key}`;
  }
}
